var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bg-white d-flex flex-column justify-content-between h-full",
      attrs: { flat: "" },
    },
    [
      _c(
        "ul",
        { staticClass: "thread-list" },
        [
          _vm._l(_vm.threads, function (thread) {
            return [
              _c("div", { key: thread.id }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "text-decoration-none d-flex justify-space-between align-center",
                    on: {
                      click: function ($event) {
                        return _vm.clickThread(thread.id)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(thread.createdAt.slice(0, 10)) +
                        " " +
                        _vm._s(thread.name) +
                        "\n          "
                    ),
                    _c(
                      "v-menu",
                      {
                        attrs: { "offset-y": "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "me-2",
                                          attrs: {
                                            small: "",
                                            icon: "",
                                            color: "indigo",
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c("v-icon", { attrs: { dark: "" } }, [
                                        _vm._v("mdi-dots-vertical"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "v-list",
                          [
                            _c(
                              "v-list-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openDeleteDialog(thread)
                                  },
                                },
                              },
                              [_c("v-list-item-title", [_vm._v("削除")])],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openEditDialog(thread)
                                  },
                                },
                              },
                              [_c("v-list-item-title", [_vm._v("名前の編集")])],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", {
                  staticClass: "divider",
                  attrs: { role: "presentation" },
                }),
                _vm._v(" "),
                _c("hr"),
              ]),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "320" },
          model: {
            value: _vm.showDeleteDialog,
            callback: function ($$v) {
              _vm.showDeleteDialog = $$v
            },
            expression: "showDeleteDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v("本当に削除してもよろしいですか？")]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.showDeleteDialog = false
                        },
                      },
                    },
                    [_vm._v("\n          キャンセル\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: {
                        click: function ($event) {
                          return _vm.deleteThread()
                        },
                      },
                    },
                    [_vm._v("\n          OK\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "350" },
          model: {
            value: _vm.showEditDialog,
            callback: function ($$v) {
              _vm.showEditDialog = $$v
            },
            expression: "showEditDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v("スレッド名の編集")]),
              _vm._v(" "),
              _c("v-card-text", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.threadName,
                      expression: "threadName",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.threadName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.threadName = $event.target.value
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.showEditDialog = false
                        },
                      },
                    },
                    [_vm._v("\n          キャンセル\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: {
                        click: function ($event) {
                          return _vm.editThread()
                        },
                      },
                    },
                    [_vm._v("\n          OK\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }